import {
  ElementRef,
  ViewChild,
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { FileUploader } from 'ng2-file-upload';
import { ContactService } from '@app/core/services/contact/contact.service';

export interface IFileAux {
  file: File;
  base64: string | ArrayBuffer;
}

@Component({
  selector: 'app-file-upload-input',
  templateUrl: './file-upload-input.component.html',
  styleUrls: ['./file-upload-input.component.scss'],
})
export class FileUploadInputComponent implements OnChanges {
  @Input() label;

  /**
   * Campo opcional.
   * Este campo foi criado para permitir múltiplas inputs de upload na mesma tela pois,
   * como o id é definido dentro deste componente e cada input deveria possuir um id único,
   * um arquivo selecionado em uma file input pode ser carregado dentro de outra file input na mesma tela.
   * Passar nesse formato: [id]="['documento-file-upload-input']".
   * Se passar assim não permitirá o carregamento do arquivo: id="documento-file-upload-input".
   * Se não for recebido o id então utilizará por padrão id=file-upload-input por padrão.
   */
  @Input() id;

  @Input() control: FormArray;

  @Input() allowedExtensions: string;

  @Input() uploaderInstance: FileUploader;

  @Input() multiple: boolean = false;

  @Input() isLimited: boolean = false;

  @Input() maxFile: number = 1;

  @Input() isViewButtonAttach: boolean = false;

  @Input() infoTooltip: string = '';

  @Output() handleFileBase64 = new EventEmitter<Array<IFileAux>>();

  @ViewChild('attachments') attachment: any;

  @ViewChild('inputFileRef') acompanhamento: ElementRef;

  constructor(private formBuilder: FormBuilder, private contactService: ContactService) {}

  get fileList(): File[] {
    return (this.control.value as Array<IFileAux>).map(({ file }) => file);
  }

  //this.attachment.nativeElement.value = '';
  /*} else {
      const file = fileInput.target.file[0];*/
  get fileName(): string[] {
    return this.fileList.map(({ name }) => name);
  }

  get errors(): boolean {
    if (this.control) {
      return this.control.invalid && (this.control.dirty || this.control.touched);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.control) {
      const control = changes.control.currentValue as FormArray;
      control.valueChanges.subscribe((files: IFileAux[]) => {
        this.handleFileBase64.emit(files);
        this.customMaxFilesValidator(files.length, control);
      });
    }
  }

  sendFile(fileRead: FileReader[], typeRead) {
    setTimeout(() => {
      let cpf = localStorage.getItem('LOCAL_CPF');
      let tkn = localStorage.getItem('LOCAL_STORAGE_TOKEN_REPORT');
      if (
        cpf != null &&
        cpf != '' &&
        cpf != undefined &&
        tkn != null &&
        tkn != '' &&
        tkn != undefined
      ) {
        fileRead.forEach((element) => {
          let file = element.result.toString().split(',')[1];
          let type = typeRead;
          console.log(file);

          let payload = {
            cpf: localStorage.getItem('LOCAL_CPF'),
            extensao: type,
            file: file,
            token: localStorage.getItem('LOCAL_STORAGE_TOKEN_REPORT'),
          };

          this.contactService.sendReportFile(payload).subscribe((data) => {
            console.log(data);
          });
        });
      }
    }, 2000);
  }

  public buttonClick() {
    this.acompanhamento.nativeElement.click();
  }

  public async fileChangeEvent(fileList: FileList) {
    const files = this.multiple ? Array.from(fileList) : [fileList.item(0)];

    for (let file of files) {
      if (!this.fileList.includes(file)) {
        await this.readFile(file);
      }
    }

    this.acompanhamento.nativeElement.value = '';
    this.control.markAllAsTouched();
  }

  public removeFile(e: Event, i: number) {
    e.preventDefault();
    this.control.removeAt(i);
  }

  public resetInput() {
    this.control.reset();
  }

  private createItem(data: IFileAux): FormGroup {
    return this.formBuilder.group(data);
  }

  private customMaxFilesValidator(numFiles: number, control: AbstractControl) {
    if (this.isLimited && numFiles > this.maxFile) {
      control.setErrors({
        maxFiles: {
          maxFile: this.maxFile,
        },
      });
    } else if (control.getError('maxFiles')) {
      control.setErrors({
        maxFiles: null,
      });
      control.updateValueAndValidity({ emitEvent: false });
    }
  }

  private readFile(file: File): Promise<void> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const item = this.createItem({
          file,
          base64: e.target.result,
        });

        if (!this.multiple) {
          this.control.clear();
        }

        this.control.push(item);
        resolve();
      };
      reader.readAsDataURL(file);

      console.log('CHEGOU');

      this.sendFile([reader], file.name.split('.')[1].toLowerCase());
    });
  }
}
